import Stack from "@mui/material/Stack";
import LanguageContext from "components/LanguageContext";
import Wrapper from "components/LayoutFront/Wrapper";
import LastNewsBlock from "components/templatesComponents/LastNewsBlock";
import SeparatorDSFR from "components/templatesComponents/SeparatorDSFR";
import PropTypes from "prop-types";
import React, { useContext } from "react";
import t from "utils/locales/translation.json";

const HomeNewsDsfr = (props) => {
  const { page: pageVersion = {} } = props;
  const { contents, page } = pageVersion;
  const { lang } = page;
  const { highlightedNews, homeButton } = contents;
  const { language } = useContext(LanguageContext);

  return (
    <>
      <SeparatorDSFR />
      <Wrapper>
        <Stack
          direction={{ md: "row" }}
          spacing={2}
          sx={{
            justifyContent: "space-between",
            alignItems: { xs: "flex-start", lg: "center" },
            mt: 2,
            mb: 3,
            "& h2": { flex: 1 },
            "& a": { backgroundImage: "none", ml: 3 },
          }}
        >
          <h2>{t[language].last_news.subpages_title}</h2>
          {homeButton}
        </Stack>
        <LastNewsBlock highlightedNews={highlightedNews} lang={lang} />
      </Wrapper>
    </>
  );
};

HomeNewsDsfr.propTypes = {
  page: PropTypes.shape(),
};

export default HomeNewsDsfr;
